import { defineMessages } from '../../i18n/index.ts'

export const levelsMessages = defineMessages({
	en: {
		startGo: 'Make 3 levels',
		hubTitle: 'Text at 3 levels',
		hubShort: 'Text levels',
		hubBlurb:
			'One text, rewritten three ways: easy, medium and hard. Same facts, so a mixed class reads the same story.',
		pickTitle: 'Rewrite a text at three levels',
		pickLead: 'Start with the text. You get an easy, a medium and a hard version of it.',
		link: 'Text at 3 levels',
		opening: 'Opening your source',
		openFailed: 'Could not open this source',
		back: 'Back to the source',
		pageTitle: (title: string) => `${title} at three levels`,
		lead: 'Same facts, different words and sentence length, in the language of the text.',
		make: 'Rewrite at 3 levels',
		making: 'Rewriting... this takes about a minute',
		again: 'Rewrite again',
		failed: 'The rewrite did not come back',
		progress: (pct: number) =>
			`${pct}% done. A long text takes a few minutes; you can leave this page and come back.`,
		stopped: 'The rewrite stopped before it finished. Try again.',
		partial: 'Not every level was made',
		partialBody: (names: string) =>
			`No text here for: ${names}. It came back almost unchanged from your text, or it was deleted. Rewrite again for a new set.`,
		noText: 'This source has no text yet. Add the text first.',
		easy: 'Easy',
		medium: 'Medium',
		hard: 'Hard',
		makeExercises: 'Make exercises from this',
		print: 'Print this level',
		printAll: 'Print all three',
		earlier: 'Earlier rewrites',
		tryAgain: 'Try again',
		emptyTitle: 'One text, three levels',
		levelLabel: 'Level',
	},
	ro: {
		startGo: 'Fă cele 3 niveluri',
		hubTitle: 'Text la 3 niveluri',
		hubShort: 'Niveluri text',
		hubBlurb:
			'Un text rescris în trei feluri: ușor, mediu și dificil. Aceleași fapte, deci o clasă mixtă citește aceeași poveste.',
		pickTitle: 'Rescrie un text la trei niveluri',
		pickLead: 'Începe cu textul. Primești o variantă ușoară, una medie și una dificilă.',
		link: 'Text la 3 niveluri',
		opening: 'Se deschide sursa ta',
		openFailed: 'Nu am putut deschide această sursă',
		back: 'Înapoi la sursă',
		pageTitle: (title: string) => `${title} la trei niveluri`,
		lead: 'Aceleași fapte, cuvinte și propoziții de lungimi diferite, în limba textului.',
		make: 'Rescrie la 3 niveluri',
		making: 'Se rescrie... durează cam un minut',
		again: 'Rescrie din nou',
		failed: 'Rescrierea nu a venit',
		progress: (pct: number) =>
			`${pct}% gata. Un text lung durează câteva minute; poți părăsi pagina și reveni.`,
		stopped: 'Rescrierea s-a oprit înainte să se termine. Încearcă din nou.',
		partial: 'Nu s-au creat toate nivelurile',
		partialBody: (names: string) =>
			`Lipsește aici: ${names}. A ieșit aproape identic cu textul tău sau a fost șters. Rescrie din nou pentru un set nou.`,
		noText: 'Această sursă nu are încă text. Adaugă mai întâi textul.',
		easy: 'Ușor',
		medium: 'Mediu',
		hard: 'Dificil',
		makeExercises: 'Creează exerciții din acesta',
		print: 'Tipărește acest nivel',
		printAll: 'Tipărește toate trei',
		earlier: 'Rescrieri anterioare',
		tryAgain: 'Încearcă din nou',
		emptyTitle: 'Un text, trei niveluri',
		levelLabel: 'Nivel',
	},
	ru: {
		startGo: 'Сделать 3 уровня',
		hubTitle: 'Текст на 3 уровнях',
		hubShort: 'Уровни текста',
		hubBlurb:
			'Один текст, переписанный тремя способами: лёгкий, средний и сложный. Факты те же, поэтому смешанный класс читает одну историю.',
		pickTitle: 'Переписать текст на трёх уровнях',
		pickLead: 'Начните с текста. Вы получите лёгкий, средний и сложный вариант.',
		link: 'Текст на 3 уровнях',
		opening: 'Открываем ваш источник',
		openFailed: 'Не удалось открыть этот источник',
		back: 'Назад к источнику',
		pageTitle: (title: string) => `${title} на трёх уровнях`,
		lead: 'Те же факты, другие слова и длина предложений, на языке текста.',
		make: 'Переписать на 3 уровнях',
		making: 'Переписываем... это займёт около минуты',
		again: 'Переписать ещё раз',
		failed: 'Переписанный текст не пришёл',
		progress: (pct: number) =>
			`Готово ${pct}%. Длинный текст переписывается несколько минут; можно уйти со страницы и вернуться.`,
		stopped: 'Переписывание остановилось, не закончив. Попробуйте ещё раз.',
		partial: 'Созданы не все уровни',
		partialBody: (names: string) =>
			`Здесь нет: ${names}. Текст вышел почти без изменений по сравнению с вашим или был удалён. Перепишите снова, чтобы получить новый набор.`,
		noText: 'В этом источнике пока нет текста. Сначала добавьте текст.',
		easy: 'Лёгкий',
		medium: 'Средний',
		hard: 'Сложный',
		makeExercises: 'Составить упражнения по нему',
		print: 'Распечатать этот уровень',
		printAll: 'Распечатать все три',
		earlier: 'Прежние варианты',
		tryAgain: 'Попробовать снова',
		emptyTitle: 'Один текст, три уровня',
		levelLabel: 'Уровень',
	},
	fr: {
		startGo: 'Créer les 3 niveaux',
		hubTitle: 'Texte à 3 niveaux',
		hubShort: 'Niveaux de texte',
		hubBlurb:
			'Un texte réécrit de trois façons : facile, moyen et difficile. Mêmes faits, pour qu’une classe hétérogène lise la même histoire.',
		pickTitle: 'Réécrire un texte à trois niveaux',
		pickLead:
			'Commencez par le texte. Vous obtenez une version facile, une moyenne et une difficile.',
		link: 'Texte à 3 niveaux',
		opening: 'Ouverture de votre source',
		openFailed: 'Impossible d’ouvrir cette source',
		back: 'Retour à la source',
		pageTitle: (title: string) => `${title} à trois niveaux`,
		lead: 'Mêmes faits, mots et longueur de phrases différents, dans la langue du texte.',
		make: 'Réécrire à 3 niveaux',
		making: 'Réécriture en cours... environ une minute',
		again: 'Réécrire encore',
		failed: 'La réécriture n’est pas arrivée',
		progress: (pct: number) =>
			`${pct} % fait. Un long texte prend quelques minutes ; vous pouvez quitter cette page et revenir.`,
		stopped: 'La réécriture s’est arrêtée avant la fin. Réessayez.',
		partial: 'Tous les niveaux n’ont pas été créés',
		partialBody: (names: string) =>
			`Il manque ici : ${names}. Le texte est resté presque identique au vôtre, ou il a été supprimé. Réécrivez pour obtenir un nouveau jeu.`,
		noText: 'Cette source n’a pas encore de texte. Ajoutez d’abord le texte.',
		easy: 'Facile',
		medium: 'Moyen',
		hard: 'Difficile',
		makeExercises: 'Créer des exercices à partir de celui-ci',
		print: 'Imprimer ce niveau',
		printAll: 'Imprimer les trois',
		earlier: 'Réécritures précédentes',
		tryAgain: 'Réessayer',
		emptyTitle: 'Un texte, trois niveaux',
		levelLabel: 'Niveau',
	},
	it: {
		startGo: 'Crea i 3 livelli',
		hubTitle: 'Testo a 3 livelli',
		hubShort: 'Livelli di testo',
		hubBlurb:
			'Un testo riscritto in tre modi: facile, medio e difficile. Stessi fatti, così una classe mista legge la stessa storia.',
		pickTitle: 'Riscrivi un testo a tre livelli',
		pickLead: 'Parti dal testo. Ottieni una versione facile, una media e una difficile.',
		link: 'Testo a 3 livelli',
		opening: 'Apertura della tua fonte',
		openFailed: 'Impossibile aprire questa fonte',
		back: 'Torna alla fonte',
		pageTitle: (title: string) => `${title} a tre livelli`,
		lead: 'Stessi fatti, parole e lunghezza delle frasi diverse, nella lingua del testo.',
		make: 'Riscrivi a 3 livelli',
		making: 'Riscrittura in corso... ci vuole circa un minuto',
		again: 'Riscrivi di nuovo',
		failed: 'La riscrittura non è arrivata',
		progress: (pct: number) =>
			`${pct}% fatto. Un testo lungo richiede qualche minuto; puoi lasciare questa pagina e tornare.`,
		stopped: 'La riscrittura si è fermata prima di finire. Riprova.',
		partial: 'Non tutti i livelli sono stati creati',
		partialBody: (names: string) =>
			`Qui manca: ${names}. È uscito quasi identico al tuo testo, oppure è stato eliminato. Riscrivi per avere un nuovo set.`,
		noText: 'Questa fonte non ha ancora un testo. Aggiungi prima il testo.',
		easy: 'Facile',
		medium: 'Medio',
		hard: 'Difficile',
		makeExercises: 'Crea esercizi da questo',
		print: 'Stampa questo livello',
		printAll: 'Stampa tutti e tre',
		earlier: 'Riscritture precedenti',
		tryAgain: 'Riprova',
		emptyTitle: 'Un testo, tre livelli',
		levelLabel: 'Livello',
	},
	kk: {
		startGo: '3 деңгей жасау',
		hubTitle: 'Мәтін 3 деңгейде',
		hubShort: 'Мәтін деңгейлері',
		hubBlurb:
			'Бір мәтін үш түрде қайта жазылады: жеңіл, орташа және қиын. Деректер бірдей, сондықтан аралас сынып бір оқиғаны оқиды.',
		pickTitle: 'Мәтінді үш деңгейде қайта жазу',
		pickLead: 'Мәтіннен бастаңыз. Жеңіл, орташа және қиын нұсқасын аласыз.',
		link: 'Мәтін 3 деңгейде',
		opening: 'Материалыңыз ашылуда',
		openFailed: 'Бұл материалды ашу мүмкін болмады',
		back: 'Материалға оралу',
		pageTitle: (title: string) => `${title}: үш деңгей`,
		lead: 'Деректер бірдей, сөздер мен сөйлем ұзындығы әртүрлі, мәтін тілінде.',
		make: '3 деңгейде қайта жазу',
		making: 'Қайта жазылуда... шамамен бір минут',
		again: 'Қайта жазу',
		failed: 'Қайта жазылған мәтін келмеді',
		progress: (pct: number) =>
			`${pct}% дайын. Ұзын мәтін бірнеше минут алады; беттен шығып, кейін оралуға болады.`,
		stopped: 'Қайта жазу аяқталмай тоқтап қалды. Қайталап көріңіз.',
		partial: 'Барлық деңгей жасалмады',
		partialBody: (names: string) =>
			`Мұнда жоқ: ${names}. Ол сіздің мәтініңізден дерлік айырмашылығы жоқ болып шықты немесе жойылды. Жаңа жинақ алу үшін қайта жазыңыз.`,
		noText: 'Бұл материалда әлі мәтін жоқ. Алдымен мәтінді қосыңыз.',
		easy: 'Жеңіл',
		medium: 'Орташа',
		hard: 'Қиын',
		makeExercises: 'Осыдан жаттығу жасау',
		print: 'Осы деңгейді басып шығару',
		printAll: 'Үшеуін де басып шығару',
		earlier: 'Бұрынғы нұсқалар',
		tryAgain: 'Қайта көру',
		emptyTitle: 'Бір мәтін, үш деңгей',
		levelLabel: 'Деңгей',
	},
	es: {
		startGo: 'Crear los 3 niveles',
		hubTitle: 'Texto en 3 niveles',
		hubShort: 'Niveles de texto',
		hubBlurb:
			'Un texto reescrito de tres maneras: fácil, medio y difícil. Los mismos hechos, para que una clase mixta lea la misma historia.',
		pickTitle: 'Reescribe un texto en tres niveles',
		pickLead: 'Empieza por el texto. Recibes una versión fácil, una media y una difícil.',
		link: 'Texto en 3 niveles',
		opening: 'Abriendo tu material',
		openFailed: 'No se pudo abrir este material',
		back: 'Volver al material',
		pageTitle: (title: string) => `${title} en tres niveles`,
		lead: 'Los mismos hechos, con otras palabras y otra longitud de frases, en el idioma del texto.',
		make: 'Reescribir en 3 niveles',
		making: 'Reescribiendo... tarda cerca de un minuto',
		again: 'Reescribir otra vez',
		failed: 'La reescritura no llegó',
		progress: (pct: number) =>
			`${pct} % hecho. Un texto largo tarda unos minutos; puedes salir de esta página y volver.`,
		stopped: 'La reescritura se detuvo antes de terminar. Inténtalo de nuevo.',
		partial: 'No se crearon todos los niveles',
		partialBody: (names: string) =>
			`Aquí falta: ${names}. Salió casi igual que tu texto, o se eliminó. Reescribe para obtener un juego nuevo.`,
		noText: 'Este material aún no tiene texto. Añade primero el texto.',
		easy: 'Fácil',
		medium: 'Medio',
		hard: 'Difícil',
		makeExercises: 'Crear ejercicios con este',
		print: 'Imprimir este nivel',
		printAll: 'Imprimir los tres',
		earlier: 'Reescrituras anteriores',
		tryAgain: 'Intentar de nuevo',
		emptyTitle: 'Un texto, tres niveles',
		levelLabel: 'Nivel',
	},
	pt: {
		startGo: 'Criar os 3 níveis',
		hubTitle: 'Texto em 3 níveis',
		hubShort: 'Níveis de texto',
		hubBlurb:
			'Um texto reescrito de três formas: fácil, médio e difícil. Os mesmos fatos, para que uma turma mista leia a mesma história.',
		pickTitle: 'Reescreva um texto em três níveis',
		pickLead: 'Comece pelo texto. Você recebe uma versão fácil, uma média e uma difícil.',
		link: 'Texto em 3 níveis',
		opening: 'Abrindo seu material',
		openFailed: 'Não foi possível abrir este material',
		back: 'Voltar ao material',
		pageTitle: (title: string) => `${title} em três níveis`,
		lead: 'Os mesmos fatos, com outras palavras e outro tamanho de frases, no idioma do texto.',
		make: 'Reescrever em 3 níveis',
		making: 'Reescrevendo... leva cerca de um minuto',
		again: 'Reescrever de novo',
		failed: 'A reescrita não veio',
		progress: (pct: number) =>
			`${pct}% feito. Um texto longo leva alguns minutos; pode sair desta página e voltar.`,
		stopped: 'A reescrita parou antes de terminar. Tente de novo.',
		partial: 'Nem todos os níveis foram criados',
		partialBody: (names: string) =>
			`Falta aqui: ${names}. Saiu quase igual ao seu texto, ou foi excluído. Reescreva para obter um novo conjunto.`,
		noText: 'Este material ainda não tem texto. Adicione o texto primeiro.',
		easy: 'Fácil',
		medium: 'Médio',
		hard: 'Difícil',
		makeExercises: 'Criar exercícios com este',
		print: 'Imprimir este nível',
		printAll: 'Imprimir os três',
		earlier: 'Reescritas anteriores',
		tryAgain: 'Tentar de novo',
		emptyTitle: 'Um texto, três níveis',
		levelLabel: 'Nível',
	},
	de: {
		startGo: '3 Stufen erstellen',
		hubTitle: 'Text in 3 Stufen',
		hubShort: 'Textstufen',
		hubBlurb:
			'Ein Text, auf drei Arten umgeschrieben: leicht, mittel und schwer. Dieselben Fakten, damit eine gemischte Klasse dieselbe Geschichte liest.',
		pickTitle: 'Einen Text in drei Stufen umschreiben',
		pickLead:
			'Fang mit dem Text an. Du bekommst eine leichte, eine mittlere und eine schwere Fassung.',
		link: 'Text in 3 Stufen',
		opening: 'Dein Material wird geöffnet',
		openFailed: 'Dieses Material konnte nicht geöffnet werden',
		back: 'Zurück zum Material',
		pageTitle: (title: string) => `${title} in drei Stufen`,
		lead: 'Dieselben Fakten, andere Wörter und Satzlängen, in der Sprache des Textes.',
		make: 'In 3 Stufen umschreiben',
		making: 'Wird umgeschrieben... das dauert etwa eine Minute',
		again: 'Noch einmal umschreiben',
		failed: 'Die Umschreibung kam nicht zurück',
		progress: (pct: number) =>
			`${pct} % fertig. Ein langer Text dauert ein paar Minuten; du kannst die Seite verlassen und zurückkommen.`,
		stopped: 'Das Umschreiben hat vor dem Ende aufgehört. Versuch es noch einmal.',
		partial: 'Nicht alle Stufen wurden erstellt',
		partialBody: (names: string) =>
			`Hier fehlt: ${names}. Es kam fast unverändert zurück oder wurde gelöscht. Schreib noch einmal um, für einen neuen Satz.`,
		noText: 'Dieses Material hat noch keinen Text. Füge zuerst den Text hinzu.',
		easy: 'Leicht',
		medium: 'Mittel',
		hard: 'Schwer',
		makeExercises: 'Übungen daraus erstellen',
		print: 'Diese Stufe drucken',
		printAll: 'Alle drei drucken',
		earlier: 'Frühere Fassungen',
		tryAgain: 'Erneut versuchen',
		emptyTitle: 'Ein Text, drei Stufen',
		levelLabel: 'Stufe',
	},
})
